export const DEFAULT_MINIMUM_TIME_TO_BE_VISIBLE = 1000
export const DEFAULT_EMPTY_TIME = 0

export const IS_CLIENT = typeof window !== 'undefined'

export const POSITION_DATA_ATTRIBUTE = 'data-ad-position'
export const DEFAULT_QUERY_SELECTOR = `[${POSITION_DATA_ATTRIBUTE}]`

const DEFAULT_OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 1
}

export const OBSERVER_OPTIONS = {
  DESKTOP: DEFAULT_OBSERVER_OPTIONS,
  MOBILE: {...DEFAULT_OBSERVER_OPTIONS, threshold: 0.5}
}

export const MINIMUM_TIME_TO_BE_VISIBLE = {
  DESKTOP: DEFAULT_MINIMUM_TIME_TO_BE_VISIBLE,
  MOBILE: DEFAULT_MINIMUM_TIME_TO_BE_VISIBLE
}
